
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.75 12.45A.748.748 0 013 11.7c0-.2.078-.389.219-.53l1.833-1.834a1.712 1.712 0 011.218-.504c.46 0 .892.179 1.217.503l1.144 1.147a.218.218 0 00.156.064c.06 0 .116-.023.157-.065L11.67 7.76c.324-.324.756-.503 1.217-.503s.893.179 1.217.503l2.091 2.091a.222.222 0 00.314-.001l3.213-3.184a.744.744 0 01.528-.217.746.746 0 01.75.754.746.746 0 01-.222.529l-3.211 3.182a1.705 1.705 0 01-1.214.501c-.46 0-.893-.179-1.218-.503l-2.091-2.091a.222.222 0 00-.313.001l-2.726 2.721c-.324.324-.756.503-1.217.503s-.893-.179-1.217-.503l-1.144-1.147a.217.217 0 00-.156-.063.222.222 0 00-.158.065L4.281 12.23a.747.747 0 01-.531.22z"}}),_c('path',{attrs:{"d":"M8.921 23.997a.752.752 0 01-.45-1.351l2.779-2.084v-1.875h-9.5c-.965 0-1.75-.785-1.75-1.75V3.188c0-.965.785-1.75 1.75-1.75h9.308V.75a.75.75 0 011.5 0v.688h9.692c.965 0 1.75.785 1.75 1.75v13.75c0 .965-.785 1.75-1.75 1.75h-9.5v1.875l2.776 2.082a.75.75 0 01-.899 1.201L12 21.875l-2.629 1.971a.741.741 0 01-.45.151zM1.75 2.938a.25.25 0 00-.25.25v13.75c0 .138.112.25.25.25h20.5a.25.25 0 00.25-.25V3.188a.25.25 0 00-.25-.25H1.75z"}})])
          )
        }
      }
    